import {
  Exercise, Level, Phase, ScheduleEntryColourCode, SessionSequence,
   UserExerciseSession, WorkoutSettings,
} from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';

// used for empty studio gym states
export class StudioEmptyWithoutAudioBeeps implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
    previousExerciseSessions?: UserExerciseSession[],
    exerciseFormatDescription?: string,
    loop?: number,
  ): SessionSequence[] {

    return [{
      durationInMilliseconds: 120,
      sequence: [{
        durationInMilliseconds: 120,
        videoFile: exercise.uniqueReferenceNumber,
        exerciseVersion: exercise._rev,
        displayName: exercise.name,
        displayBurnOrBuildIcon: false,
        progressColourCode: ScheduleEntryColourCode.Rest,
        progressText: '',
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        audioSoundEvent: undefined,
        tips: [],
        phase: Phase.Rest,
        zone,
      }],
    }];
  }
}
